import React, { useEffect, useRef } from "react";
import { useNavigate, useParams } from "react-router-dom";
import { toast } from "react-toastify";
import Text from "../../utils/commonComponent/Custom/text";
import CommonForm from "../../utils/commonComponent/commonForm";
import {
  AddButton,
  CancelButton,
  SaveAndUpdate,
} from "../../utils/commonComponent/Custom/Button";
import {
  fetchByTable,
  fetchQuery,
} from "./../../utils/commonComponent/fetched";
import axiosWithToken from "../../utils/commonComponent/axiosTokenConfig";
import { BASE_URL } from "../../global";
import { DisciplineOptions } from "../disciplineMaster/disiplineConst";
import LoaderModal from "../../utils/loader.js/loader";
import { getPermissions } from "../rbac/hasAccess";
import { validateRequiredFields } from "../../utils/commonComponent/errorAlert";
import { Button, MenuItem, Select } from "@mui/material";
import moment from "moment";

const deepEqual = (a, b) => {
  if (a === b) return true;
  if (a == null || b == null) return a === b;
  if (typeof a !== "object" || typeof b !== "object") return String(a) === String(b);
  const keysA = Object.keys(a);
  const keysB = Object.keys(b);
  if (keysA.length !== keysB.length) return false;
  return keysA.every((key) => deepEqual(a[key], b[key]));
};

const VERSION_KEYS = ["certificateNo", "calibrationLab", "calDate", "dueDate", "certificateUrl"];
const pickVersionFields = (obj = {}) =>
  VERSION_KEYS.reduce((acc, key) => { acc[key] = obj[key] ?? null; return acc; }, {});

const EditEquipmentsMaster = (props) => {
  const params = useParams();
  const permissions = getPermissions(props.moduleId);
  const navigate = useNavigate();
  const [inputStates, setInputStates] = React.useState({
    disciplineId: 0,
  });
  const [versionInputStates, setversionInputStates] = React.useState({});
  const [downloadPdfloading, setDownlaodPdfLoading] = React.useState(false);
  const [equipmentsMasterVersionsArray, setEquipmentsMasterVersionsArray] =
    React.useState([]);
  const [selectedVersion, setSelectedVersion] = React.useState(null);
  const [showForm, setShowForm] = React.useState(false);
  const [newAddedVersion, setNewAddedVersion] = React.useState(false);

  const initialInputStates = useRef(null);
  const initialVersionInputStates = useRef(null);

  const inputFields = [
    {
      type: "Autocomplete",
      label: "Discipline *",
      stateKey: "disciplineId",
      options: DisciplineOptions,
      valueKey: "id",
      getOptionLabelKey: "label",
    },
    {
      type: "Autocomplete",
      label: "Group *",
      stateKey: "groupId",
      options: `discipline where name=${inputStates?.disciplineId}`,
      valueKey: "id",
      getOptionLabelKey: "groupName",
    },
    { type: "TextField", label: "Equipment Name *", stateKey: "equipmentName" },
    {
      type: "Textarea",
      label: "Equipment Id ",
      stateKey: "equipmentId",
    },
    { type: "Textarea", label: "Serial Number", stateKey: "serialNo" },

    { type: "Textarea", label: "Make *", stateKey: "make" },
    { type: "Textarea", label: "Model *", stateKey: "model" },

    {
      type: "UnitModal",
      label: "Range *",
      stateKey: "masterrange",
      groupId: inputStates?.groupId,
    },
    {
      type: "UnitModal",
      label: "Least Count *",
      stateKey: "masterleastcount",
      groupId: inputStates?.groupId,
    },
    {
      type: "Textarea",
      label: "Calibration Certificate Number *",
      stateKey: "certificateNo",
      disabled: params.id != 0,
    },
    {
      type: "Textarea",
      label: "Calibration Lab *",
      stateKey: "calibrationLab",
      disabled: params.id != 0,
    },
    {
      type: "DatePicker",
      label: "Calibration Date *",
      stateKey: "calDate",
      disabled: params.id != 0,
    },
    {
      type: "DatePicker",
      label: "Due Date *",
      stateKey: "dueDate",
      disablePastDates: true,
      minimumDate: inputStates?.calDate,
      disabled: params.id != 0,
    },

    {
      type: "ImageUpload",
      label: "Upload Certificate",
      stateKey: "certificateUrl",
      disabled: params.id != 0,
    },
  ];

  const lastVersion = equipmentsMasterVersionsArray?.[equipmentsMasterVersionsArray.length - 1];
  const isLastVersion = newAddedVersion || selectedVersion?.id === lastVersion?.id;

  const versionInputFields = [
    {
      type: "Textarea",
      label: "Calibration Certificate Number *",
      stateKey: "certificateNo",
      disabled: !isLastVersion,
    },
    {
      type: "Textarea",
      label: "Calibration Lab *",
      stateKey: "calibrationLab",
      disabled: !isLastVersion,
    },
    {
      type: "DatePicker",
      label: "Calibration Date *",
      stateKey: "calDate",
      disabled: !isLastVersion,
      ...(newAddedVersion && {
        disablePastDates: true,
        minimumDate: moment(inputStates?.dueDate)
          .subtract(15, "days")
          .format("YYYY-MM-DD"),
      }),
    },
    {
      type: "DatePicker",
      label: "Due Date *",
      stateKey: "dueDate",
      disabled: !isLastVersion,
      disablePastDates: true,
      minimumDate: inputStates?.calDate,
    },

    {
      type: "ImageUpload",
      label: "Upload Certificate",
      stateKey: "certificateUrl",
      disabled: !isLastVersion,
    },
  ];

  const updateInputObject = (key, value) => {
    setInputStates((prevInputStates) => ({
      ...prevInputStates,
      [key]: value,
    }));
  };

  const updateVersionInputObject = (key, value) => {
    setversionInputStates((prevInputStates) => ({
      ...prevInputStates,
      [key]: value,
    }));
  };

  const fetchEquipmentsMasterDetails = async () => {
    try {
      const [equipmentsMaster] = await fetchQuery(
        `SELECT * FROM equipmentsMaster WHERE id = ${params.id}`
      );
      setInputStates(equipmentsMaster);
      initialInputStates.current = equipmentsMaster;
    } catch (error) {
      console.error("Error fetching client:", error);
    }
  };

  const onSubmit = () => {
    const fieldsToValidate = [
      { value: inputStates.disciplineId, label: "Discipline is required" },
      { value: inputStates.groupId, label: "Group is required" },
      { value: inputStates.equipmentName, label: "Equipment Name is required" },
      {
        value: inputStates.equipmentId || inputStates.serialNo,
        label: "Equipment ID or Serial Number is required",
      },
      { value: inputStates.make, label: "Make is required" },
      { value: inputStates.model, label: "Model is required" },
      { value: inputStates.masterrange, label: "Range is required" },
      { value: inputStates.masterleastcount, label: "Least Count is required" },
      {
        value: inputStates.certificateNo,
        label: "Calibration Certificate Number is required",
      },
      { value: inputStates.calDate, label: "Calibration Date is required" },
      { value: inputStates.dueDate, label: "Due Date is required" },
      // { value: inputStates.certificateUrl, label: "Certificate Upload is required" },
    ];
    if (!validateRequiredFields(fieldsToValidate)) {
      return;
    }

    if (newAddedVersion) {
      const versionFieldsToValidate = [
        { value: versionInputStates.certificateNo, label: "Calibration Certificate Number is required" },
        { value: versionInputStates.calibrationLab, label: "Calibration Lab is required" },
        { value: versionInputStates.calDate, label: "Calibration Date is required" },
        { value: versionInputStates.dueDate, label: "Due Date is required" },
      ];
      if (!validateRequiredFields(versionFieldsToValidate)) return;
    }

    if (params.id != 0) {
      const versionChanged =
        showForm &&
        !deepEqual(initialVersionInputStates.current, pickVersionFields(versionInputStates));

      if (showForm && !versionChanged && !newAddedVersion) {
        toast.info("No changes.");
        return;
      }

      const shouldWriteVersion = newAddedVersion || versionChanged;

      const payload = {
        ...inputStates,
        calDate: moment(newAddedVersion ? versionInputStates.calDate : inputStates.calDate).format("YYYY-MM-DD"),
        dueDate: moment(newAddedVersion ? versionInputStates.dueDate : inputStates.dueDate).format("YYYY-MM-DD"),
        certificateNo: newAddedVersion ? versionInputStates.certificateNo : inputStates.certificateNo,
        calibrationLab: newAddedVersion ? versionInputStates.calibrationLab : inputStates.calibrationLab,
      };

      setDownlaodPdfLoading(true);
      const url = BASE_URL + `equipmentsMaster`;
      const versionUrl = BASE_URL + `equipmentsMasterVersions`;

      axiosWithToken
        .patch(url + `/${params.id}`, payload)
        .then(() => {
          if (!shouldWriteVersion) {
            setDownlaodPdfLoading(false);
            toast.success("EquipmentsMaster Updated Successfully!");
            setTimeout(() => window.location.reload(), 1000);
            return;
          }

          let versionPayload = {
            equipmentMasterId: params.id,
            versionNumber: equipmentsMasterVersionsArray.length + 1,
            ...versionInputStates,
            calDate: moment(versionInputStates.calDate).format("YYYY-MM-DD"),
            dueDate: moment(versionInputStates.dueDate).format("YYYY-MM-DD"),
          };

          const versionRequest =
            selectedVersion?.id && !newAddedVersion
              ? axiosWithToken.patch(versionUrl + `/${selectedVersion?.id}`, versionPayload)
              : axiosWithToken.post(versionUrl, versionPayload);

          return versionRequest;
        })
        .then((res) => {
          if (res) {
            setDownlaodPdfLoading(false);
            toast.success("EquipmentsMaster Updated Successfully!");
            setTimeout(() => window.location.reload(), 1000);
          }
        })
        .catch((error) => {
          setDownlaodPdfLoading(false);
          console.error("Submit error:", error);
        });

      return;
    }

    let versionPayload = {
      equipmentMasterId: params.id,
      versionNumber: equipmentsMasterVersionsArray.length + 1 || 1,
      ...versionInputStates,
      calDate: moment(versionInputStates.calDate).format("YYYY-MM-DD"),
      dueDate: moment(versionInputStates.dueDate).format("YYYY-MM-DD"),
    };

    const payload = {
      ...inputStates,
      calDate: moment(inputStates.calDate).format("YYYY-MM-DD"),
      dueDate: moment(inputStates.dueDate).format("YYYY-MM-DD"),
    };

    setDownlaodPdfLoading(true);
    const url = BASE_URL + `equipmentsMaster`;
    const versionUrl = BASE_URL + `equipmentsMasterVersions`;

    axiosWithToken
      .post(url, payload)
      .then((res) => {
        const request = axiosWithToken.post(versionUrl, {
          ...versionPayload,
          equipmentMasterId: res.data.insertId,
        });

        setDownlaodPdfLoading(false);
        toast.success("EquipmentsMaster Created Successfully!");
        setTimeout(() => navigate("/master/masterEquipment"), 1000);
      })
      .catch((error) => {
        setDownlaodPdfLoading(false);
        console.error("Submit error:", error);
      });
  };

  const reloadPage = () => {
    setTimeout(() => {
      window.location.reload();
    }, 500);
  };

  const fetchEquipmentsMasterVersionDetails = async () => {
    try {
      const newEquipmentsMasterVersionsArray = await fetchQuery(
        `SELECT * FROM equipmentsMasterVersions WHERE equipmentMasterId = ${params.id}`
      );
      setEquipmentsMasterVersionsArray(newEquipmentsMasterVersionsArray);
      const latestVersion = newEquipmentsMasterVersionsArray?.[newEquipmentsMasterVersionsArray.length - 1];
      if (latestVersion) {
        initialVersionInputStates.current = pickVersionFields(latestVersion);
      }
    } catch (error) {
      console.error("Error fetching client:", error);
    }
  };

  useEffect(() => {
    if (params.id != 0) {
      fetchEquipmentsMasterDetails();
      fetchEquipmentsMasterVersionDetails();
    }
  }, [params]);

  useEffect(() => {
    if (!versionInputFields?.length) return;

    const lastVersion =
      equipmentsMasterVersionsArray?.[equipmentsMasterVersionsArray.length - 1];
    const isLatestVersion = selectedVersion?.id === lastVersion?.id;
    const isNewVersion = params?.id == 0;

    // ✅ Run if: new version OR latest version
    if (isNewVersion || isLatestVersion) {
      const updater = isNewVersion
        ? updateVersionInputObject
        : updateInputObject;

      versionInputFields.forEach(({ stateKey }) => {
        const value = isNewVersion
          ? inputStates?.[stateKey]
          : versionInputStates?.[stateKey] ?? inputStates?.[stateKey];

        if (value !== undefined) {
          updater(stateKey, value);
        }
      });
    }

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [
    params?.id,
    selectedVersion?.id,
    equipmentsMasterVersionsArray,
    ...versionInputFields.map((f) => inputStates?.[f.stateKey]),
    ...versionInputFields.map((f) => versionInputStates?.[f.stateKey]),
  ]);

  useEffect(() => {
    if (selectedVersion) {
      setversionInputStates({ ...selectedVersion });
      initialVersionInputStates.current = pickVersionFields(selectedVersion);
    } else {
      setversionInputStates({});
    }
  }, [selectedVersion]);

  return (
    <div>
      <Text variant="h3" bold className="text-blue-600">
        {params.id == 0 ? "Create New Equipment" : `Update Equipment `}
      </Text>
      <br />
      <CommonForm
        inputStates={inputStates}
        updateInputObject={updateInputObject}
        inputFields={inputFields}
      />
      <br />
      {params?.id != 0 && (
        <>
          <hr />
          <br />
          <div style={{ display: "flex", alignItems: "center", gap: "10px" }}>
            <Select
              size="small"
              value={selectedVersion?.id || ""}
              onChange={(e) => {
                const selectedId = e.target.value;
                const selectedObj = equipmentsMasterVersionsArray.find(
                  (item) => item.id === selectedId
                );
                setSelectedVersion(selectedObj || null);
                setShowForm(!!selectedObj);
                setNewAddedVersion(false);
              }}
              displayEmpty
              style={{ minWidth: "150px" }}
            >
              <MenuItem value="">Select Version</MenuItem>
              {equipmentsMasterVersionsArray.map((item) => (
                <MenuItem key={item.id} value={item.id}>
                  {`V${item.versionNumber}`}
                </MenuItem>
              ))}
            </Select>

            <AddButton
              id="btn-add-version"
              label="Add Version"
              onClick={() => {
                setSelectedVersion(null);
                setShowForm(true);
                setNewAddedVersion(true);
                setversionInputStates({});
                initialVersionInputStates.current = null;
              }}
              disabled={selectedVersion}
            />
          </div>
          {showForm && (
            <>
              <br />
              <CommonForm
                inputStates={versionInputStates}
                updateInputObject={updateVersionInputObject}
                inputFields={versionInputFields}
              />
              <br />
            </>
          )}
        </>
      )}
      <div className="flex gap-10 mt-5 justify-end ">
        <CancelButton
          id="btn-cancel"
          label="Cancel"
          outline
          onClick={() => {
            if (window.confirm("Are you sure you want to cancel?")) {
              window.history.back();
            }
          }}
        />
        {(permissions.save || permissions.allAccess) && (
          <SaveAndUpdate
            id="btn-add-outline"
            label={params.id == 0 ? "Save" : "Update"}
            onClick={onSubmit}
          />
        )}
      </div>
      {downloadPdfloading && <LoaderModal loading={downloadPdfloading} />}
    </div>
  );
};

export default EditEquipmentsMaster;